import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PlantTopHead from './plant-top-head';
import PlantContent from './plant-content';
import PlantModals from './plant-modals';
import { actions as plantActions, fetchPlantsWithFilters } from './store/slice';

const { resetFilters } = plantActions;

const PlantView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchPlantsWithFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Plant</h4>
              </div>
            </div>
            <PlantTopHead />
          </div>
          <PlantContent />
          <PlantModals />
        </div>
      </div>
    </div>
  );
};

export default PlantView;
